module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step4_4-17aed2c60c9c587c09441803e2d2918e.png";